<template>
  <!-- EDITACE ZARIZENI NA DETAILU ZARIZENI -->
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="item != undefined"
      :class="{
        opened: opened.indexOf('editItem') >= 0,
        'last-active': opened.indexOf('editItem') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEditConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="editItem()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("BTN_ULOZIT_ZMENY") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ item.iccid }}</h2>
      </div>
      <div class="side-box__content">
        <div class="my-4">
          <a
            :class="{ opened: infoOpened }"
            class="atom-form-group__toggler"
            @click="infoOpened = infoOpened ? false : true"
          >
            {{ $t("vaseInformaceOZarizeni") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: infoOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("nazevZarizeni") }}</span>
              <div class="side-box__content__input custom-control__custom-input ml-3">
                <span v-if="!simcard.friendlyName" class="placeholder">{{ $t("zadejteNazevZarizeni") }}</span>
                <input
                  v-model="simcard.friendlyName"
                  autofocus
                  class="w-100"
                  maxlength="32"
                  placeholder=""
                  type="text"
                  @click="changedEvent"
                />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("prepnoutDoRezimu") }}</span>
              <div class="side-box__content__input custom-control__select ml-3">
                <div
                  :class="{ opened: statusOpened }"
                  class="custom-control__select__selected d-flex"
                  @click="statusOpened = statusOpened ? false : true"
                >
                  <div class="d-flex flex-wrap">
                    <span v-if="editedItem.status == ''" class="gray-text">{{ $t("vyberteRezim") }}</span>
                    <div v-else class="">
                      <div v-if="selectedState == 'RESUME'">
                        <div class="d-flex">
                          <div class="atom-circle atom-circle--success mr-2">A</div>
                          <span>{{ $t("active") }}</span>
                        </div>
                      </div>
                      <div v-if="selectedState == 'SUSPEND'">
                        <div class="d-flex">
                          <div class="atom-circle atom-circle--gray mr-2">S</div>
                          <span>{{ $t("SUSPENDED") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="{ opened: statusOpened }" class="custom-control__select__options">
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        selectedState = 'RESUME'
                        statusOpened = statusOpened = false
                      }
                    "
                  >
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--success mr-2">A</div>
                      <span>{{ $t("active") }}</span>
                    </div>
                  </div>
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        selectedState = 'SUSPEND'
                        statusOpened = statusOpened = false
                      }
                    "
                  >
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--gray mr-2">S</div>
                      <span>{{ $t("SUSPENDED") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedEditConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEditConfirmation"
      @no="closeBox('editItem')"
      @yes="editItem()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            closeBox('editItem')
            openedError = false
          }
        "
      />
    </div>
    <div v-if="errorsToTranslate1.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate1" :opened="openedError1" @close="openedError1 = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    opened: Array,
    item: Object
  },
  setup() {
    const projectStore = useProjectStore()
    const authStore = useAuthStore()

    return { projectStore, authStore }
  },
  data() {
    return {
      changed: false,
      statusOpened: false,
      selectedState: "",
      lastDevice: {},
      infoOpened: true,
      openedError: false,
      errorsToTranslate: [],
      openedError1: false,
      openedEditConfirmation: false,
      errorsToTranslate1: [],
      error: {
        custDeviceName: false
      },
      stateMap: {
        ACTIVE: "RESUME",
        SUSPENDED: "SUSPEND"
      },
      simcard: {}
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    editedItem() {
      return Object.assign({}, this.item)
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    project() {
      this.simcard = Object.assign({}, this.item)
    },
    opened() {}
  },
  mounted() {
    this.simcard = Object.assign({}, this.item)
    this.selectedState = this.stateMap[this.item.status]
    this.simcard.friendlyName = this.item.friendlyName
  },
  methods: {
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      this.resetValues()
      this.$emit("closeBox", box)
    },
    closeStatus() {
      if (this.statusOpened) {
        this.statusOpened = false
      }
    },
    showWaiting() {
      console.log("showWaiting")
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
    },
    hideWaiting() {
      this.$store.commit("modals/setWaitingLoader", "")
    },
    editItem() {
      this.errorsToTranslate = []

      this.showWaiting()

      let promises = []
      if (this.stateMap[this.item.status] != this.selectedState) {
        promises.push(
          axios
            .post(
              process.env.VUE_APP_API +
                "/simcards/service/" +
                this.editedItem.custServiceId +
                "/" +
                this.editedItem.iccid +
                "/status",
              { action: this.selectedState }
            )
            .then(() => {
              return true
            })
            .catch((error) => {
              this.errorsToTranslate.push(error.data)
            })
        )
      }

      if (this.simcard.friendlyName.length > 0 && this.simcard.friendlyName != this.item.friendlyName) {
        promises.push(
          axios
            .put(
              process.env.VUE_APP_API +
                "/simcards/service/" +
                this.editedItem.custServiceId +
                "/" +
                this.editedItem.iccid,
              { friendlyName: this.simcard.friendlyName }
            )
            .then(() => {
              return true
            })
            .catch((error) => {
              this.errorsToTranslate.push(error.data)
            })
        )
      }

      Promise.all(promises).then(() => {
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
          this.$emit("reloadItems")
        } else {
          let cacheUpdateAt = new Date()
          cacheUpdateAt.setSeconds(cacheUpdateAt.getSeconds() + 30)
          localStorage.setItem("simcardsCacheUpdateAt", cacheUpdateAt)
          this.$emit("info")
          this.$emit("reloadItems")
          this.$emit("closeBox", "editItem")
        }
      })
      return true
    },
    toggleEditConfirmation() {
      console.log("toggleEditConfirmation")
      if (this.changed) {
        this.openedEditConfirmation = this.openedEditConfirmation ? false : true
      } else {
        this.openedEditConfirmation = false
        this.$emit("closeBox", "editItem")
      }
    },
    resetValues() {
      this.editItem.friendlyName = this.item.friendlyName
      this.selectedState = this.stateMap[this.item.status]
    }
  }
}
</script>

<style lang="scss" scoped></style>
